import { featureFlagService } from '@superbet-group/web.lib.flags';
import {
    computed,
    onMounted,
    onUnmounted,
    ref,
    watch,
} from '@vue/composition-api';
import { Unsubscribe } from '@superbet-group/web.lib.feature-toggle-service';
import { referAFriendService } from '@core/services/referAFriend/ReferAFriendService';
import { errorGuard } from '@core/utils/ErrorGuard';

function useReferAFriendFlag() {
    let featureSubscriptionUnsubscribeFn: Unsubscribe | undefined;
    const isReferAFriendFlagEnabled = ref(false);
    const isReferAFriendEligible = ref(false);
    const isReferAFriendLoading = ref(true);
    const isReferAFriendEnabled = computed(
        () => isReferAFriendFlagEnabled.value && isReferAFriendEligible.value,
    );

    function loadFlag() {
        featureSubscriptionUnsubscribeFn = featureFlagService.subscribeToFeatureChanges(
            'ops.refer-a-friend',
            (isEnabled) => {
                if (!isEnabled) {
                    return;
                }
                // we simply got true from the flag
                if (
                    (isEnabled && !isEnabled.metadata)
                    || (isEnabled.value && !isEnabled.metadata.context.anonymous)
                ) {
                    isReferAFriendFlagEnabled.value = true;
                }
            },
            false,
            {
                includeMetadata: true,
            },
        );
    }

    watch(isReferAFriendFlagEnabled, (isEnabled) => {
        errorGuard(async () => {
            if (isEnabled) {
                const userEligibility = await referAFriendService.getEligibility();
                isReferAFriendEligible.value = userEligibility.eligible;
            }
        });
    });

    onMounted(async () => {
        await errorGuard(() => loadFlag());

        // After 3 sec, if still not enabled, stop loading
        setTimeout(() => {
            isReferAFriendLoading.value = false;
        }, 3000);
    });

    onUnmounted(() => {
        featureSubscriptionUnsubscribeFn?.();
    });

    return {
        isReferAFriendEnabled,
        isReferAFriendLoading: computed(
            () => !isReferAFriendEnabled.value && isReferAFriendLoading.value,
        ),
    };
}

export default useReferAFriendFlag;
